export const EDITOR_ACTIONS = {
  "EDITOR_INIT":"[Admin Report Template] REPORT_TEMPLATE_INIT",
  "SET_EDITOR_WORKLIST":"[Admin Report Template] REPORT_TEMPLATE_SET_WORKLIST",
  "SET_EDITOR_VARIABLES": "[Admin Report Template] REPORT_EDITOR_SET_VARIABLES",
  "SET_EDITOR_JSON_BASE": "[Admin Report Template] REPORT_EDITOR_SET_JSON_BASE"
};
